import { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { useRbac } from '@/hooks/useRbac';
import { StockLookupModal } from './StockLookupModal';

/**
 * TCR-1954 — icon "Tra cứu tồn kho" trên header, cạnh chuông thông báo.
 *
 * `@ant-design/icons` 5.6.1 trong repo không có icon hộp-kèm-kính-lúp như thiết kế
 * (không có `ProductOutlined`), nên vẽ thẳng SVG thay vì lấy `ContainerOutlined` cho
 * gần giống.
 */
function StockLookupIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M21 8.5 12 3 3 8.5v7L12 21l4-2.4" />
      <path d="M3 8.5 12 14l9-5.5" />
      <path d="M12 14v7" />
      <circle cx="17.5" cy="15.5" r="3" />
      <path d="m20 18 2.5 2.5" />
    </svg>
  );
}

export function StockLookupButton() {
  const { hasPermission } = useRbac();
  const [open, setOpen] = useState(false);

  // Quyền này CỐ Ý độc lập: không suy ra từ inventory.stock.view hay
  // inventory.warehouse.* (xem catalogue trong role-seed.service.ts).
  if (!hasPermission('inventory.stock_lookup.view')) return null;

  return (
    <>
      <Tooltip title="Tra cứu tồn kho">
        <Button
          type="text"
          icon={<StockLookupIcon />}
          aria-label="Tra cứu tồn kho"
          onClick={() => setOpen(true)}
          data-testid="stock-lookup-trigger"
        />
      </Tooltip>
      <StockLookupModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
